<template>
  <div class="container-while">
    <!-- 顶部文字容器 -->
    <div class="cut-top-section">
      <div class="cutwhile-text-container" ref="cutWhileTextContainer">
        <div class="text1" ref="text1">{{ $t('series.fly_cutting') }}</div>
        <div class="text2" ref="text2">{{ $t('series.fly_cutting2') }}</div>
        <div class="text3" ref="text3">{{ $t('series.fly_cutting3') }}</div>
      </div>
    </div>

    <!-- 底部图片 -->
    <div class="image-container" ref="cutWhileImageContainer">
      <img src="../../static/series/cutbed/cut-while3.png" class="device-image"
           ref="cutWhileDeviceImage">
      <div class="cut-bottom-image1">
        <img src="../../static/series/cutbed/cut-while1.png">
      </div>
      <img class="cut-bottom-image2" src="../../static/series/cutbed/cut-while2.png" alt="裁剪示意图2">
    </div>

    <div class="cutwhile-bottom-content" ref="cutWhileBottomContent">
      <div style="display: flex;flex-direction: column;" v-if="this.$i18n.locale === 'zh'">
        <span class="cut-bottom-text1">边走边裁</span><br>
        <span class="cut-bottom-text2">快得太吓人。</span><br>
        <span class="cut-bottom-text3">最快达</span><br>
        <div class="cut-bottom-content2">
          <span class="cut-bottom-text4">1.3倍</span>
          <span class="cut-bottom-text5">裁剪缩短时间</span>
        </div>
      </div>
      <div v-else>
        <span class="cut-bottom-text1">{{ $t('series.fly_cutting4') }}</span><br>
        <div class="cut-bottom-content2">
          <span class="cut-bottom-text4">{{ $t('series.fly_cutting7') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CutWhileMoving',
  data() {
    return {
      resizeHandler: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 初始化动画
      this.initAnimations();

      // 监听窗口大小变化，优化性能使用节流
      this.resizeHandler = this.throttle(() => {
        this.adjustLayoutForScreenSize();
      }, 100);

      window.addEventListener('resize', this.resizeHandler);
    });
  },
  beforeUnmount() {
    // 移除事件监听
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  },
  methods: {
    // 节流函数，优化resize性能
    throttle(func, delay) {
      let lastTime = 0;
      return function (...args) {
        const now = Date.now();
        if (now - lastTime >= delay) {
          func.apply(this, args);
          lastTime = now;
        }
      };
    },

    // 初始化动画
    initAnimations() {
      // 初始设置
      this.$gsap.set(this.$refs.cutWhileTextContainer, {
        y: '20%', // 使用相对单位
      });

      // 隐藏箭头
      this.$gsap.set('.cut-bottom-image2', {
        opacity: 0
      });

      this.$gsap.set('.cut-bottom-image1', {
        scaleY: 0.6,
      });


      // 创建主时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.container-while',
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none none',
          once: true
        }
      });

      // 根据屏幕宽度动态调整动画距离
      const xDistance = window.innerWidth < 768 ? '30%' : '15%';

      masterTimeline.from(
          [this.$refs.cutWhileTextContainer, '.image-container'],
          {
            opacity: 0,
            x: xDistance,
            duration: 1.5,
            ease: 'power2.in'
          }, 0.5);

      // 移动箭头
      masterTimeline.to(
          ['.cut-bottom-image2'],
          {
            opacity: 1,
            x: xDistance,
            duration: 1.5,
            ease: 'power2.in'
          }, 2);
      masterTimeline.to('.cut-bottom-image1', {
        opacity: 1,
        duration: 1.5,
        x: xDistance,
        ease: 'power2.in'
      }, 2);

      masterTimeline.from('.cutwhile-bottom-content', {
        duration: 1.5,
        opacity: 0,
        x: xDistance,
        ease: 'power2.in'
      }, 2.5);
    },

    // 根据屏幕尺寸调整布局
    adjustLayoutForScreenSize() {
      const isMobile = window.innerWidth < 768;
      const bottomContent = this.$refs.cutWhileBottomContent;

      // 调整底部内容位置
      if (bottomContent) {
        this.$gsap.set(bottomContent, {
          left: isMobile ? '5%' : '50vw',
          marginLeft: isMobile ? 0 : '100px'
        });
      }

      // 调整图片位置
      const img1 = document.querySelector('.cut-bottom-image1');
      const img2 = document.querySelector('.cut-bottom-image2');

      if (img1 && img2) {
        if (isMobile) {
          this.$gsap.set(img1, {left: '-15%'});
          this.$gsap.set(img2, {left: '5%'});
        } else {
          this.$gsap.set(img1, {left: '-29%'});
          this.$gsap.set(img2, {left: '10%'});
        }
      }
    }
  }
};
</script>

<style scoped>
/* 外层容器 */
.container-while {
  background-color: #000;
  color: #fff;
  padding: 2vw; /* 使用视口单位 */
  box-sizing: border-box;
  overflow: hidden;
  min-height: 1100px; /* 使用视口高度确保全屏 */
  position: relative;
}

/* 顶部区域 */
.cut-top-section {
  display: flex;
  justify-content: center; /* 居中布局 */
  align-items: flex-start;
  width: 100%;
  margin-bottom: 5vh; /* 使用视口高度单位 */
  padding-top: 5vh;
}

/* 左侧文字容器 */
.cutwhile-text-container {
  flex: 1;
  max-width: 600px;
  padding: 2vw 0;
  text-align: left;
  margin-left: 5vw; /* 左侧间距使用视口单位 */
}

/* 文字样式 */
.text1 {
  font-size: clamp(1.5rem, 3vw, 2.5rem); /* 响应式字体 */
  font-weight: bold;
  margin-bottom: 0.5vw;
}

.text2 {
  font-size: clamp(1.5rem, 3vw, 2.5rem);
  background: linear-gradient(90deg, #66CCFF, #0066CC);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.text3 {
  width: 100%; /* 适应容器宽度 */
  max-width: 55%;
  font-size: clamp(1rem, 2vw, 1.3rem);
  color: #808080;
  line-height: 1.5;
  margin-top: 2vw;
}

/* 图片容器样式 */
.image-container {
  margin: 5vh auto 0;
  position: relative;
  z-index: 1;
  text-align: center; /* 图片居中 */
  width: 90%;
}

/* 装饰图片定位 */
.cut-bottom-image1 {
  position: absolute;
  top: 6.5vw;
  width: 100%; /* 相对宽度 */
  height: auto;
  left: -60%;
}

.cut-bottom-image2 {
  position: absolute;
  left: 35vw;
  top: 6.5vw;
  z-index: 1;
  width: 40%; /* 相对宽度 */
  height: auto;
  transform: translateX(-50%); /* 居中对齐 */
}

/* 主图片样式 */
.device-image {
  height: auto;
  max-height: 400px;
  max-width: 100%; /* 最大宽度限制 */
  border-radius: 4px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* 底部内容样式 */
.cutwhile-bottom-content {
  margin-top: 5vh;
  position: absolute;
  text-align: left;
  left: 50vw;
}

.cut-bottom-text1 {
  font-size: clamp(1.2rem, 2vw, 1.8rem);
}

.cut-bottom-text2 {
  background: linear-gradient(90deg, #cc40bb, #e18ed8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: clamp(1.5rem, 3vw, 2.5rem);
}

.cut-bottom-text3 {
  font-size: clamp(1.2rem, 2vw, 1.8rem);
  color: #808080;
}

.cut-bottom-text4 {
  font-size: clamp(2rem, 4vw, 3rem);
}

.cut-bottom-text5 {
  font-size: clamp(1.2rem, 2vw, 1.8rem);
  color: #808080;
  margin-left: 1vw;
}

.cut-bottom-content2 {
  display: flex;
  align-items: baseline;
  margin-top: -20px;
}

/* 平板设备适配 */
@media (max-width: 992px) {
  .text3 {
    max-width: 80%;
  }

  .cutwhile-bottom-content {
    left: 10vw;
    margin-left: 0;
  }
}

/* 手机设备适配 */
@media (max-width: 767px) {
  .cutwhile-text-container {
    margin-left: 0;
    padding: 0 5vw;
  }

  .text3 {
    max-width: 100%;
  }

  .image-container {
    margin-top: 3vh;
  }

  .device-image {
    max-height: 300px;
  }

  .cutwhile-bottom-content {
    left: 5vw;
    margin-top: 3vh;
  }
}

/* 小屏手机额外适配 */
@media (max-width: 375px) {
  .device-image {
    max-height: 250px;
  }
}
</style>
